import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import subsection_style from "./style.js";

import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
} from "semantic-ui-react";

import a from './images/origin/94fb08e3be3190ebff076996f7a2341ac_drawn.jpg';
import b from './images/ref/8998_drawn.png';
import cx_8998_x0_94fb08e3be3190ebff076996f7a2341ac_0 from './images/ours/cx_8998_x0_94fb08e3be3190ebff076996f7a2341ac_0.png_seed122_0.png';
import cx_8998_x0_94fb08e3be3190ebff076996f7a2341ac_2 from './images/ours/cx_8998_x0_94fb08e3be3190ebff076996f7a2341ac_2.png_seed122_2.png';
import cx_8998_x0_94fb08e3be3190ebff076996f7a2341ac_3 from './images/ours/cx_8998_x0_94fb08e3be3190ebff076996f7a2341ac_3.png_seed122_3.png';
import c from './images/origin/353642766087c9c32f77460eacb34442c_drawn.jpg';
import d from './images/ref/74533_drawn.png';
import cx_74533_x0_353642766087c9c32f77460eacb34442c_0 from './images/ours/cx_74533_x0_353642766087c9c32f77460eacb34442c_0.png_seed120_0.png';
import cx_74533_x0_353642766087c9c32f77460eacb34442c_2 from './images/ours/cx_74533_x0_353642766087c9c32f77460eacb34442c_2.png_seed120_2.png';
import cx_74533_x0_353642766087c9c32f77460eacb34442c_3 from './images/ours/cx_74533_x0_353642766087c9c32f77460eacb34442c_3.png_seed120_3.png';
import ea88abb8440b62f68ed2996708fdd47fc_drawn from './images/origin/ea88abb8440b62f68ed2996708fdd47fc_drawn.jpg';
import e from './images/ref/57242_drawn.png';
import cx_57242_x0_ea88abb8440b62f68ed2996708fdd47fc_0 from './images/ours/cx_57242_x0_ea88abb8440b62f68ed2996708fdd47fc_0.png_seed121_0.png';
import cx_57242_x0_ea88abb8440b62f68ed2996708fdd47fc_2 from './images/ours/cx_57242_x0_ea88abb8440b62f68ed2996708fdd47fc_2.png_seed121_2.png';
import cx_57242_x0_ea88abb8440b62f68ed2996708fdd47fc_3 from './images/ours/cx_57242_x0_ea88abb8440b62f68ed2996708fdd47fc_3.png_seed121_3.png';
import f from './images/origin/6b54f9c0e754751b2e6014f0153b64bbc_drawn.jpg';
import g from './images/ref/38310_drawn.png';
import cx_38310_x0_6b54f9c0e754751b2e6014f0153b64bbc_0 from './images/ours/cx_38310_x0_6b54f9c0e754751b2e6014f0153b64bbc_0.png_seed124_0.png';
import cx_38310_x0_6b54f9c0e754751b2e6014f0153b64bbc_2 from './images/ours/cx_38310_x0_6b54f9c0e754751b2e6014f0153b64bbc_2.png_seed124_2.png';
import cx_38310_x0_6b54f9c0e754751b2e6014f0153b64bbc_3 from './images/ours/cx_38310_x0_6b54f9c0e754751b2e6014f0153b64bbc_3.png_seed124_3.png';
import dfcb29a1633bbd3dbdb8083bcedd299ac_drawn from './images/origin/dfcb29a1633bbd3dbdb8083bcedd299ac_drawn.jpg';
import h from './images/ref/29466_drawn.png';
import cx_29466_x0_dfcb29a1633bbd3dbdb8083bcedd299ac_0 from './images/ours/cx_29466_x0_dfcb29a1633bbd3dbdb8083bcedd299ac_0.png_seed123_0.png';
import cx_29466_x0_dfcb29a1633bbd3dbdb8083bcedd299ac_1 from './images/ours/cx_29466_x0_dfcb29a1633bbd3dbdb8083bcedd299ac_1.png_seed123_1.png';
import cx_29466_x0_dfcb29a1633bbd3dbdb8083bcedd299ac_3 from './images/ours/cx_29466_x0_dfcb29a1633bbd3dbdb8083bcedd299ac_3.png_seed123_3.png';
import i from './images/origin/7a2e8af80d678114c8538713a2969e88c_drawn.jpg';
import j from './images/ref/439439_drawn.png';
import cx_439439_x0_7a2e8af80d678114c8538713a2969e88c_0 from './images/ours/cx_439439_x0_7a2e8af80d678114c8538713a2969e88c_0.png_seed124_0.png';
import cx_439439_x0_7a2e8af80d678114c8538713a2969e88c_1 from './images/ours/cx_439439_x0_7a2e8af80d678114c8538713a2969e88c_1.png_seed124_1.png';
import cx_439439_x0_7a2e8af80d678114c8538713a2969e88c_2 from './images/ours/cx_439439_x0_7a2e8af80d678114c8538713a2969e88c_2.png_seed124_2.png';

import clock from './images/sd/clock2.png';
import flower from './images/sd/flower1.png';
import fridge from './images/sd/fridge1.png';
import train from './images/sd/train2.png';

import css from './results.css'

const ResultStyle = {
  fontSize: "1.5em",
  fontWeight: "normal",
  marginBottom: "0em",
  marginTop: "0em",
};

const ImageResults = () => (
  <div>
    <Grid columns={6} columnSpacing={1} >
      <Grid.Row
        textAlign="center" verticalAlign="middle" style={{ marginTop: "0.5em" }}>
        <Grid.Column>
          <p> Original </p>
        </Grid.Column>
        <Grid.Column>
          <p> Reference </p>
        </Grid.Column>
        <Grid.Column>
          {/* <p> Seed 1 </p> */}
        </Grid.Column>
        <Grid.Column>
          <p> <b> RefPaint</b> </p>
        </Grid.Column>
        <Grid.Column>
          {/* <p> Seed 3 </p> */}
        </Grid.Column>
        <Grid.Column>
          <p> Stable Diffusion </p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row
        textAlign="center" style={{ marginTop: "0em" }}>
        <Grid.Column>

          <Image src={a} style={ResultStyle}></Image>

        </Grid.Column>
        <Grid.Column>
          <Image src={b} style={ResultStyle}></Image>

        </Grid.Column>
        <Grid.Column>

          <Image src={cx_8998_x0_94fb08e3be3190ebff076996f7a2341ac_0} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>

          <Image src={cx_8998_x0_94fb08e3be3190ebff076996f7a2341ac_2} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={cx_8998_x0_94fb08e3be3190ebff076996f7a2341ac_3} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={clock} style={ResultStyle}></Image>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row
        textAlign="center">
        <Grid.Column>
          <Image src={c} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={d} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={cx_74533_x0_353642766087c9c32f77460eacb34442c_0} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={cx_74533_x0_353642766087c9c32f77460eacb34442c_2} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={cx_74533_x0_353642766087c9c32f77460eacb34442c_3} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={train} style={ResultStyle}></Image>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row
        textAlign="center">
        <Grid.Column>
          <Image src={ea88abb8440b62f68ed2996708fdd47fc_drawn} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={e} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={cx_57242_x0_ea88abb8440b62f68ed2996708fdd47fc_0} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={cx_57242_x0_ea88abb8440b62f68ed2996708fdd47fc_2} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={cx_57242_x0_ea88abb8440b62f68ed2996708fdd47fc_3} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={flower} style={ResultStyle}></Image>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row
        textAlign="center">
        <Grid.Column>
          <Image src={i} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={j} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={cx_439439_x0_7a2e8af80d678114c8538713a2969e88c_0} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={cx_439439_x0_7a2e8af80d678114c8538713a2969e88c_1} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={cx_439439_x0_7a2e8af80d678114c8538713a2969e88c_2} style={ResultStyle}></Image>
        </Grid.Column>
        <Grid.Column>
          <Image src={fridge} style={ResultStyle}></Image>
        </Grid.Column>
      </Grid.Row>
    </Grid>
    <br></br>
    <p>
      Visual results for <u>Ref</u>erence-based <u>Paint</u>erly Inpainting framework (RefPaint) results using <b>random</b> inpainting masks and <b>random</b> objects from COCO Captions dataset. <font style={{ color: 'blue' }}> Blue </font> bounding box represents the edited regions where we would like to inpaint. <font style={{ color: 'red' }}> Red </font> boundaries indicate the reference object.
    </p>
  </div>
);

export default ImageResults;







